import { Link } from "react-router-dom";

export interface MigaDePan {
  etiqueta: string;
  /** Sin `ruta`: es el nivel actual — no clickeable. */
  ruta?: string;
}

// Breadcrumbs reutilizables para pantallas secundarias (ej. Configuración /
// Procesos de Trabajo / Accidentes de tránsito / Vista Kanban). No se usa en
// pantallas principales (Dashboard, listados de primer nivel) — ahí no
// aporta nada y sería ruido.
export function MigasDePan({ items }: { items: MigaDePan[] }) {
  if (items.length === 0) return null;
  return (
    <nav aria-label="Migas de pan" className="mb-2 flex flex-wrap items-center gap-1.5 text-xs text-texto-secundario">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <span aria-hidden="true">/</span>}
          {item.ruta ? (
            <Link to={item.ruta} className="transition-colors hover:text-texto hover:underline">
              {item.etiqueta}
            </Link>
          ) : (
            <span aria-current="page" className="text-texto">
              {item.etiqueta}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}
